<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :search-input.sync="search"
    :label="label"
    :items="items"
    item-text="name"
    item-value="id"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    clearable
  )
</template>

<script>
import { CRUDQuestionCategory } from '@/services/API/_crud';

export default {
  props: {
    value: { type: Number, default: null },
    label: { type: String, default: 'Категория шаблонов' },
    projectId: { type: Number, required: false, default: null },
    projectRoleId: { type: Number, required: false, default: null },
    isParent: { type:Boolean, required: false, default:false },
  },
  data() {
    return {
      items: [],
      loading:false,
      search: '',
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch:{
    projectRoleId() {
      this.search = '';
      this.$emit('input', null);
      this.init();
    },
    search() {
      // Items have already been requested
      if (this.loading) return;
      if (this.inputValue) return;
      this.loading = true;

      // Lazily load input items
      this.loadItems();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadItems();
    },
    async loadItems() {
      const params = {
        'search[name]' :this.search,
        'per-page': -1,
      };
      if (this.isParent) params['search[is_parent]'] = 1;
      if (this.projectRoleId) params['search[project_role_id]'] = this.projectRoleId;
      if (this.projectId) params['search[project_id]'] = this.projectId;
      this.loading = true;

      await CRUDQuestionCategory.getAll(params).then((response) => {
        this.items = response.data.data;
        this.loading = false;
      });
    },
  },
};
</script>
